import addError from '../../../utils/error.jsx';

export function request(selectionIds) {
    return {
        type: 'GET_MULTIPLES_LINE_DETAILS',
        selectionIds
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ERROR_MULTIPLES_LINE_DETAILS',
        errors
    };
}

export function finish(selections) {
    return {
        type: 'FINISH_MULTIPLES_LINE_DETAILS',
        selections
    };
}
